export var Urls = {
	local : 'http://programador.centromotors.com.co/backend/index.php/',
	fotos_ext : 'http://testcrm.centromotors.com.co/production/images/fotos/'
};